import { render, staticRenderFns } from "./KorrespondenzEmpfaengerAbsender.vue?vue&type=template&id=7641da46"
import script from "./KorrespondenzEmpfaengerAbsender.vue?vue&type=script&lang=js"
export * from "./KorrespondenzEmpfaengerAbsender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports